/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_Create_ProfileInputs */

const en_how_to_create_profile = /** @type {(inputs: How_To_Create_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How would you like to create your profile?`)
};

const de_how_to_create_profile = /** @type {(inputs: How_To_Create_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie möchtest du dein Profil erstellen?`)
};

/**
* | output |
* | --- |
* | "How would you like to create your profile?" |
*
* @param {How_To_Create_ProfileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const how_to_create_profile = /** @type {((inputs?: How_To_Create_ProfileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_Create_ProfileInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_how_to_create_profile(inputs)
	return en_how_to_create_profile(inputs)
});